import { makeRequestDeduped } from '../../../../infra/rest';
import { GetSubscribedPlanResponse } from '../typings';

export const getSubscribedPlan = () => {
  return makeRequestDeduped<GetSubscribedPlanResponse>(`/v1/plan/subscription/status`, undefined, true);
};
